import { render } from "./DefaultWorkflows.vue?vue&type=template&id=9f0bb346&scoped=true&ts=true"
import script from "./DefaultWorkflows.vue?vue&type=script&lang=ts"
export * from "./DefaultWorkflows.vue?vue&type=script&lang=ts"

import "./DefaultWorkflows.vue?vue&type=style&index=0&id=9f0bb346&lang=scss&scoped=true"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f0bb346"]])

export default __exports__